"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotStars = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotStars = _ref => {
  let {
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M19.586 5.205C16.883 1.815 12.151-.734 7.756.192a7.371 7.371 0 0 0-3.358 1.605 7.466 7.466 0 0 0-2.161 3.05C.593 7.002-.129 10.22.019 12.744c.23 4.996 4.14 7.837 8.707 8.446 4.223.567 8.95.376 11.641-3.426 2.768-3.922 2.141-8.936-.78-12.559Z",
    opacity: 0.8
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "m19.999 3.333 5.15 10.433 11.516 1.684-8.333 8.116 1.967 11.467-10.3-5.417-10.3 5.417 1.966-11.467-8.333-8.116 11.517-1.684 5.15-10.433Z"
  }));
};
exports.SpotStars = SpotStars;
SpotStars.displayName = "SpotStars";